'<template>
    <div class="preview_box">
        <div>
            <span class="preview_logo">
                <img src="../../../assets/logo.png" alt="">
            </span>
            
        </div>
        <ul class="preview_list">
            <li>
                <p>江心</p>
            </li>
            <li>
                {{information.copywriteContent}}
            </li>
            <li class="preview_goods" v-if="row.belongColumn==0">
                <span class="preview_goods_img">
                    <img :src="imgUrl+information.pictureName" alt="">
                </span>
                <span>
                    <p>{{information.itemName}}</p>
                    <p>￥{{information.minPrice}}</p>
                </span>
            </li>
            <div v-if='information.materialType==0'>
                <li class="preview_imgList" v-if='preview_imglist.length==3||preview_imglist.length==6'>
                    <div v-if='!index' class="preview_img_item preview_img_item_per" v-for="item,index in preview_imglist" >
                        <img :src="imgUrl+item" alt="">
                    </div>
                    <div class="preview_img_per_box">
                        <div class="preview_img_item preview_img_item_small" v-if='index&&index<=2' v-for="item,index in preview_imglist">
                            <img :src="imgUrl+item" alt="">
                        </div>
                    </div>
                    <div class="preview_img_item preview_img_item_small" v-if="index>2" v-for="item,index in preview_imglist" >
                        <img :src="imgUrl+item" alt="">
                    </div>
                </li>
                <li class="preview_imgList" v-else>
                    <div class="preview_img_item preview_img_item_small" :class="{'preview_img_item_big':preview_imglist.length==1,'preview_img_item_middle':(preview_imglist.length==2||preview_imglist.length==4||(preview_imglist.length==5 && (index==0||index==1))||(preview_imglist.length==7 && (index==0||index==1||index==5||index==6))||(preview_imglist.length==8 && (index==3||index==4)))}" v-for="item,index in preview_imglist" >
                        <img :src="imgUrl+item" alt="">
                    </div>
                </li>
            </div>
            <li v-if='information.materialType==1'>
                <video class="preview_video" v-if='information.videoMaterial' :src='imgUrl+information.videoMaterial'></video>
            </li>
        </ul>
    </div>
</template>
<script>
    import matterManageApi from "@/api/matterManage";
    export default {
       props: ["row"],
       data() {
           return {
               information:'',
               preview_imglist:[],/* 预览图片 */
            //    timeNow:`${new Date().getMonth()+1}-${new Date().getDate()}  ${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`,
           }
       },
       methods: {
           preview(){
               matterManageApi.preview(this.row.materialId).then(res=>{
                   if(res.data.code=='200'){
                       this.information= res.data.data
                       this.preview_imglist=this.information.pictureMaterial?this.information.pictureMaterial.split(','):''
                   }else{
                       this.$Message.error(res.data.message)
                   }
               })
           }
       },
       created() {
           this.preview()
       },
   }
</script>
<style scoped>
.preview_box{
    display: flex;
    justify-content: space-between;
}
.preview_box p{
    text-align: left;
}
.preview_logo{
    width: 55px;
    height: 55px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 12px;
    border-radius: 50%;
    overflow: hidden;
}
.preview_title{
    display: inline-block;
    vertical-align: middle;
}

.preview_list{
    width: 272px;
}
.preview_list li{
    margin-bottom: 8px
}
.preview_goods{
    display: flex;
    justify-content: space-between;
}
.preview_goods span:nth-child(1){
    width: 90px;
    height: 90px;
    margin-right: 12px;
}
.preview_goods span:nth-child(2){
    flex: 1
}
/* 底部图片的样式 */
.preview_imgList {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.preview_img_per_box{
    width: 88px;
}
.preview_img_item{
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 4px;
}
.preview_img_item img{
    width: 100%;
    height: 100%;
}
.preview_img_item_small{
    width: 88px;
    height: 88px;
}
.preview_img_item_middle{
    width: 134px;
    height: 134px;
}
.preview_img_item_big{
    width: 272px;
    height: 272px;
}
.preview_img_item_per{
    width:180px;
    height:180px;
}
.preview_video{
    width:100%;
}
</style>'